<div class="page-options-container" [style.top.px]="topOffset">
  <div class="sidenav-padding"></div>

  <div class="page-options-sub-container">
    <ng-content></ng-content>
    @if (showExpandedLayout$ | async) {
      <ng-container *ngTemplateOutlet="subOptionsTmpl"></ng-container>
      <ng-container *ngTemplateOutlet="switchTmpl"></ng-container>
    } @else {
      @if (hasSubOptions) {
        <gb-expand-filter-button (click)="togglePageOptionsExpanded()"></gb-expand-filter-button>
      }
      <ng-container *ngTemplateOutlet="switchTmpl"></ng-container>
      <div class="sub-options-container" [ngClass]="getExpanded()">
        <ng-container *ngTemplateOutlet="subOptionsTmpl"></ng-container>
      </div>
    }
  </div>

  <div class="guide-sidenav-padding"></div>

  @if (livechatEnabled) {
    <div class="live-chat-padding"></div>
  }
</div>

@if (topOffset) {
  <div [style.paddingBottom.px]="topOffset"></div>
}

<ng-template #subOptionsTmpl>
  <span #subOptions> <ng-content select="[subOptions]"></ng-content> </span>
</ng-template>

<ng-template #switchTmpl>
  <ng-content select="[switch]"></ng-content>
</ng-template>
